import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-1.png'
import _imports_1 from '@/assets/ths-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-e90fb3b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sc-outer" }
const _hoisted_2 = { class: "login-outer" }
const _hoisted_3 = { class: "login-main" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, null, -1))
const _hoisted_5 = { class: "right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    width: "50",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "智养通")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "200",
    alt: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_router_view),
          _hoisted_7
        ])
      ])
    ])
  ]))
}